import { trackFacebookEvent } from './trackFacebookEvent'
import { trackAlgoliaAnalytics } from './trackAlgoliaAnalytics'
import { pushToDataLayer } from './pushToDataLayer'

export const tracking = {
  trackFacebookEvent,
  trackAlgoliaAnalytics,
  pushToDataLayer
}
